module.exports = __webpack_public_path__ + "img/56.31a68a83.jpg";